var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtboard3Copy71(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_15443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3602 68.12L30.2202 51.4L63.6702 25.91L43.3602 68.12Z",
    fill: "#EC5569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.83 70.78C37.74 70.78 37.65 70.77 37.56 70.75C37.1 70.65 36.74 70.31 36.61 69.86L30.56 48.69L8.95 42.21C8.6 42.1 8.31 41.85 8.16 41.52C7.87 40.88 8.16 40.13 8.8 39.85L72.16 11.34C72.32 11.27 72.5 11.23 72.68 11.23C73.38 11.23 73.95 11.8 73.95 12.5V63.19C73.95 63.89 73.38 64.46 72.68 64.46C72.52 64.46 72.36 64.43 72.21 64.37L50.88 55.84L38.8 70.34C38.56 70.63 38.2 70.79 37.83 70.8V70.78ZM32.94 47.77L38.39 66.86L48.41 54.83L40.52 51.68C40.4 51.63 40.28 51.56 40.18 51.48C39.64 51.03 39.57 50.24 40.02 49.7L60.12 25.52L59.67 25.08L32.94 47.78V47.77ZM43.09 49.97L71.42 61.3V15.89L43.09 49.97ZM12.93 40.76L30.92 46.16L63.01 18.91L62.67 18.38L12.93 40.76Z",
    fill: "#060606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_15443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard3Copy71);
export default __webpack_public_path__ + "static/media/Artboard 3 copy 7 (1).17caadf3678c914802524e2cdf6ed0f1.svg";
export { ForwardRef as ReactComponent };